/* tslint:disable */
/* eslint-disable */
/**
 * Watermap Backend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * Contact: srohr-luther@brita.net
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    BasicStageContent,
    BasicStageContentFromJSON,
    BasicStageContentToJSON,
    StringIngressRequestStageContent,
    StringIngressRequestStageContentFromJSON,
    StringIngressRequestStageContentToJSON,
    StringObjectIDictionaryIngressRequestStageContent,
    StringObjectIDictionaryIngressRequestStageContentFromJSON,
    StringObjectIDictionaryIngressRequestStageContentToJSON,
} from '../models';

export interface ContentContextIdCompleteGetRequest {
    contextId: string;
}

export interface ContentContextIdFinalRequestIdGetRequest {
    contextId: string;
    requestId: string;
}

export interface ContentContextIdOriginalRequestIdGetRequest {
    contextId: string;
    requestId: string;
}

export interface ContentContextIdPostValidationRequestIdGetRequest {
    contextId: string;
    requestId: string;
}

export interface ContentContextIdProcessLayerGetRequest {
    contextId: string;
    processLayer: string | null;
    count?: number;
}

export interface ContentContextIdStage0RequestIdGetRequest {
    contextId: string;
    requestId: string;
}

export interface ContentContextIdStage1RequestIdGetRequest {
    contextId: string;
    requestId: string;
}

/**
 * 
 */
export class ContentApi extends runtime.BaseAPI {

    /**
     */
    async contentContextIdCompleteGetRaw(requestParameters: ContentContextIdCompleteGetRequest): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters.contextId === null || requestParameters.contextId === undefined) {
            throw new runtime.RequiredError('contextId','Required parameter requestParameters.contextId was null or undefined when calling contentContextIdCompleteGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/content/{contextId}/complete`.replace(`{${"contextId"}}`, encodeURIComponent(String(requestParameters.contextId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.BlobApiResponse(response);
    }

    /**
     */
    async contentContextIdCompleteGet(requestParameters: ContentContextIdCompleteGetRequest): Promise<Blob> {
        const response = await this.contentContextIdCompleteGetRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async contentContextIdFinalRequestIdGetRaw(requestParameters: ContentContextIdFinalRequestIdGetRequest): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters.contextId === null || requestParameters.contextId === undefined) {
            throw new runtime.RequiredError('contextId','Required parameter requestParameters.contextId was null or undefined when calling contentContextIdFinalRequestIdGet.');
        }

        if (requestParameters.requestId === null || requestParameters.requestId === undefined) {
            throw new runtime.RequiredError('requestId','Required parameter requestParameters.requestId was null or undefined when calling contentContextIdFinalRequestIdGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/content/{contextId}/final/{requestId}`.replace(`{${"contextId"}}`, encodeURIComponent(String(requestParameters.contextId))).replace(`{${"requestId"}}`, encodeURIComponent(String(requestParameters.requestId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.BlobApiResponse(response);
    }

    /**
     */
    async contentContextIdFinalRequestIdGet(requestParameters: ContentContextIdFinalRequestIdGetRequest): Promise<Blob> {
        const response = await this.contentContextIdFinalRequestIdGetRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async contentContextIdOriginalRequestIdGetRaw(requestParameters: ContentContextIdOriginalRequestIdGetRequest): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters.contextId === null || requestParameters.contextId === undefined) {
            throw new runtime.RequiredError('contextId','Required parameter requestParameters.contextId was null or undefined when calling contentContextIdOriginalRequestIdGet.');
        }

        if (requestParameters.requestId === null || requestParameters.requestId === undefined) {
            throw new runtime.RequiredError('requestId','Required parameter requestParameters.requestId was null or undefined when calling contentContextIdOriginalRequestIdGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/content/{contextId}/original/{requestId}`.replace(`{${"contextId"}}`, encodeURIComponent(String(requestParameters.contextId))).replace(`{${"requestId"}}`, encodeURIComponent(String(requestParameters.requestId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.BlobApiResponse(response);
    }

    /**
     */
    async contentContextIdOriginalRequestIdGet(requestParameters: ContentContextIdOriginalRequestIdGetRequest): Promise<Blob> {
        const response = await this.contentContextIdOriginalRequestIdGetRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async contentContextIdPostValidationRequestIdGetRaw(requestParameters: ContentContextIdPostValidationRequestIdGetRequest): Promise<runtime.ApiResponse<StringObjectIDictionaryIngressRequestStageContent>> {
        if (requestParameters.contextId === null || requestParameters.contextId === undefined) {
            throw new runtime.RequiredError('contextId','Required parameter requestParameters.contextId was null or undefined when calling contentContextIdPostValidationRequestIdGet.');
        }

        if (requestParameters.requestId === null || requestParameters.requestId === undefined) {
            throw new runtime.RequiredError('requestId','Required parameter requestParameters.requestId was null or undefined when calling contentContextIdPostValidationRequestIdGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/content/{contextId}/post_validation/{requestId}`.replace(`{${"contextId"}}`, encodeURIComponent(String(requestParameters.contextId))).replace(`{${"requestId"}}`, encodeURIComponent(String(requestParameters.requestId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => StringObjectIDictionaryIngressRequestStageContentFromJSON(jsonValue));
    }

    /**
     */
    async contentContextIdPostValidationRequestIdGet(requestParameters: ContentContextIdPostValidationRequestIdGetRequest): Promise<StringObjectIDictionaryIngressRequestStageContent> {
        const response = await this.contentContextIdPostValidationRequestIdGetRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async contentContextIdProcessLayerGetRaw(requestParameters: ContentContextIdProcessLayerGetRequest): Promise<runtime.ApiResponse<Array<BasicStageContent>>> {
        if (requestParameters.contextId === null || requestParameters.contextId === undefined) {
            throw new runtime.RequiredError('contextId','Required parameter requestParameters.contextId was null or undefined when calling contentContextIdProcessLayerGet.');
        }

        if (requestParameters.processLayer === null || requestParameters.processLayer === undefined) {
            throw new runtime.RequiredError('processLayer','Required parameter requestParameters.processLayer was null or undefined when calling contentContextIdProcessLayerGet.');
        }

        const queryParameters: any = {};

        if (requestParameters.count !== undefined) {
            queryParameters['count'] = requestParameters.count;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/content/{contextId}/{processLayer}`.replace(`{${"contextId"}}`, encodeURIComponent(String(requestParameters.contextId))).replace(`{${"processLayer"}}`, encodeURIComponent(String(requestParameters.processLayer))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(BasicStageContentFromJSON));
    }

    /**
     */
    async contentContextIdProcessLayerGet(requestParameters: ContentContextIdProcessLayerGetRequest): Promise<Array<BasicStageContent>> {
        const response = await this.contentContextIdProcessLayerGetRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async contentContextIdStage0RequestIdGetRaw(requestParameters: ContentContextIdStage0RequestIdGetRequest): Promise<runtime.ApiResponse<StringIngressRequestStageContent>> {
        if (requestParameters.contextId === null || requestParameters.contextId === undefined) {
            throw new runtime.RequiredError('contextId','Required parameter requestParameters.contextId was null or undefined when calling contentContextIdStage0RequestIdGet.');
        }

        if (requestParameters.requestId === null || requestParameters.requestId === undefined) {
            throw new runtime.RequiredError('requestId','Required parameter requestParameters.requestId was null or undefined when calling contentContextIdStage0RequestIdGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/content/{contextId}/stage_0/{requestId}`.replace(`{${"contextId"}}`, encodeURIComponent(String(requestParameters.contextId))).replace(`{${"requestId"}}`, encodeURIComponent(String(requestParameters.requestId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => StringIngressRequestStageContentFromJSON(jsonValue));
    }

    /**
     */
    async contentContextIdStage0RequestIdGet(requestParameters: ContentContextIdStage0RequestIdGetRequest): Promise<StringIngressRequestStageContent> {
        const response = await this.contentContextIdStage0RequestIdGetRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async contentContextIdStage1RequestIdGetRaw(requestParameters: ContentContextIdStage1RequestIdGetRequest): Promise<runtime.ApiResponse<StringObjectIDictionaryIngressRequestStageContent>> {
        if (requestParameters.contextId === null || requestParameters.contextId === undefined) {
            throw new runtime.RequiredError('contextId','Required parameter requestParameters.contextId was null or undefined when calling contentContextIdStage1RequestIdGet.');
        }

        if (requestParameters.requestId === null || requestParameters.requestId === undefined) {
            throw new runtime.RequiredError('requestId','Required parameter requestParameters.requestId was null or undefined when calling contentContextIdStage1RequestIdGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/content/{contextId}/stage_1/{requestId}`.replace(`{${"contextId"}}`, encodeURIComponent(String(requestParameters.contextId))).replace(`{${"requestId"}}`, encodeURIComponent(String(requestParameters.requestId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => StringObjectIDictionaryIngressRequestStageContentFromJSON(jsonValue));
    }

    /**
     */
    async contentContextIdStage1RequestIdGet(requestParameters: ContentContextIdStage1RequestIdGetRequest): Promise<StringObjectIDictionaryIngressRequestStageContent> {
        const response = await this.contentContextIdStage1RequestIdGetRaw(requestParameters);
        return await response.value();
    }

}
